/** PostgREST caps every response at `db-max-rows` (1000 on our project) and
 *  silently ignores a larger client-side `.limit()`, so any query that lists a
 *  whole table has to page through it. */
const PAGE_SIZE = 1000;

interface PageResult<T> {
    data: T[] | null;
    error: { message: string } | null;
}

/**
 * Run `page(from, to)` repeatedly until the table is exhausted.
 *
 * The callback must apply `.range(from, to)` to an otherwise identical query
 * (including a stable `.order(...)`, or the pages can overlap).
 */
export async function fetchAllRows<T>(
    page: (from: number, to: number) => PromiseLike<PageResult<T>>
): Promise<T[]> {
    const rows: T[] = [];
    for (let from = 0; ; from += PAGE_SIZE) {
        const { data, error } = await page(from, from + PAGE_SIZE - 1);
        if (error) throw error;
        if (!data || data.length === 0) break;
        rows.push(...data);
        if (data.length < PAGE_SIZE) break;
    }
    return rows;
}
